import React, { useState, useContext, useEffect } from 'react';
import { useSearchParams,Link } from 'react-router-dom';
import './css/SignIn.css';
import IndianFlag from '../../assets/SignIn/india_flag.svg';
import OTP_signIn from './OTP_signIn';
import history from '../../History/history';
import configData from '../../utils/config/config.json';
import { Context } from '../../services/apiContext';
import { useGlobalSpinnerActionsContext } from '../../components/loader/useloader';
import { useNotificationActionsContext } from '../../components/notificationModal/useModal';
import useAuth from '../../services/authContext';
import InfoLogo from '../../components/Info';
import { getClientIp } from '../../helperFunctions/helperFunctions';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
const SignIn = () => {
  const { logout } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const refid = searchParams.get('refid');
  const [openstatus, setopenstatus] = useState(false);
  const [showRefer, setShowRefer] = useState(true);

  useEffect(() => {
    sessionStorage.removeItem('cseData');
    const utm_source = searchParams.get('utm_source');
    const cseData = searchParams.get('q');

    contextapi.setSession(
      utm_source &&
        (utm_source.toUpperCase() === 'NSDL' ||
          utm_source.toUpperCase() === 'CDSL')
        ? utm_source
        : '',
      'utmSource'
    );
    if (cseData) {
      setShowRefer(false);
      decryptdata(cseData).then(() => {
        var cseDataMB = contextapi.getSession('cseData').Mobile;
        setMobile(cseDataMB);
      });
    }
    logout().then(() => {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('userData');
    });
  }, []);

  const contextapi = useContext(Context);
  const [step, setstep] = useState(1);
  const [referStep, setReferStep] = useState(1);

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const setNotifi = useNotificationActionsContext();
  const [resVerifyUser, setUserVerifyResponse] = useState({});
  const [mobile, setMobile] = useState('');
  const [mobileErr, setmobileErr] = useState('');

  const [mobileRefer, setMobileRefer] = useState('');
  const [mobileReferErr, setmobileReferErr] = useState('');
  const decryptdata = async (data) => {
    var url = configData.baseURLProxy;
    var postobjt = {
      data: {
        encdata: data,
        key: configData.cseKey,
      },
      url: configData.baseURLDev + '/demat/cscdecrypt',
    };
    await contextapi
      .postApiAuthCalling(url, postobjt, false)
      .then((res) => {
        console.log(res);

        if (res.msg === 'sucess') {
          var cseData = res.data;

          contextapi.setSession(cseData, 'cseData');
        } else {
          setNotifi({ val: true, msg: res.reponse[0].status_desc });
        }
      })
      .catch((error) => {
        console.log(error);
        setGlobalSpinner(false);
        // setNotifi({ val: true, msg: "Somthing went wrong" });
      });
  };
  const handleChange = (event, from) => {
    const phoneNumberPattern = new RegExp(/^\d+$/);
    if (
      event.target.value === '' ||
      phoneNumberPattern.test(event.target.value)
    ) {
      if (from === 'refer') {
        setMobileRefer(event.target.value);
      } else {
        setMobile(event.target.value);
      }
    }
  };

  /**
   * Method to Validate Mobile number
   */
  const validateMobileNo = (from) => {
    const phoneNumberPattern = new RegExp(/^[6-9]\d{9}$/);

    if (from === 'refer') {
      if (!phoneNumberPattern.test(mobileRefer)) {
        setmobileReferErr('Please Enter a Valid Phone Number');
      } else {
        setmobileReferErr('');
        verifyUser(from);
      }
    } else {
      if (!phoneNumberPattern.test(mobile)) {
        setmobileErr('Please Enter a Valid Phone Number');
      } else {
        setmobileErr('');
        verifyUser(from);
      }
    }

    //just for now during development
    if (step + 1 >= 2) {
      history.push('signIn');
    }
  };

  const verifyUser = async (from) => {
    setGlobalSpinner(true);
    var url = '/user/verifymobile';
    var postobjt = {
      mobile: from === 'refer' ? mobileRefer : mobile,
      user_ip: await getClientIp(),
      user_role: configData.userRole,
    };

    await contextapi
      .postApiCalling(url, postobjt)
      .then((res) => {
        // console.log(res);
        if (res.status_code === '00') {
          res.mobile = from === 'refer' ? mobileRefer : mobile;
          setUserVerifyResponse(res);
          if (from === 'refer') {
            setReferStep(referStep + 1);
          } else {
            setstep(step + 1);
          }
        }
        // setGlobalSpinner(false);
      })
      .catch((error) => {
        console.log('Error VerifyUser : ', error);
        // setGlobalSpinner(false);
        // setNotifi({ val: true, msg: "Something went wrong" });
        setUserVerifyResponse({ val: true, msg: 'Something went wrong' });
      });
  };

  const handleKeyPress = (event, from) => {
    if (event.key === 'Enter') {
      validateMobileNo(from);
    }
  };

  const renderLogin = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div className='col-md-6 col-sm-12 signupform'>
              <div id='signin' className='container tab-pane active p-0'>
                <div className='row'>
                  <div className='col-md-12 '>
                    <div className='signin-hdng'>
                      <h1>We’re so happy you’re here!</h1>
                      <p>
                        Login/Signup to your account by entering your mobile
                        number.
                      </p>
                    </div>

                    <div className='sign-in-fields'>
                      <div className='form-group phone-input-box'>
                        <input
                          type='text'
                          className='form-control required'
                          id='Inputmobile'
                          aria-describedby='mobile'
                          placeholder='Mobile No'
                          value={mobile}
                          onChange={handleChange}
                          maxLength={10}
                          onKeyPress={(e) => handleKeyPress(e, 'signIn')}
                          autoComplete='off'
                        />

                        <span>
                          <img src={IndianFlag} alt='' /> +91
                        </span>
                      </div>
                      {mobileErr !== '' ? (
                        <p className='text-danger'>
                          <i
                            className='pe-2 fa fa-exclamation-circle'
                            aria-hidden='true'
                          ></i>
                          {mobileErr}
                        </p>
                      ) : null}

                      <div className='form-group mb-0'>
                        {/* <button type="submit" className="btnInuse btn-default form-control colorwhite" onClick={validateMobileNo}>Validate</button> */}
                        <div className='infobtn'>
                          <InfoLogo />
                          <p>
                            This mobile number will be used for login and
                            communications in the future. 
                          </p>
                        </div>

                        <button
                          type='submit'
                          className='makewhitcolor btnInuse btn-default makewhitcolor maekitfullwidth'
                          onClick={() => validateMobileNo('signin')}
                        >
                          Validate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <div className='col-md-6 signupform'>
            <OTP_signIn data={resVerifyUser} refId={refid} />
          </div>
        );
    }
  };

  const referModalClick = (type) => {
    if (type === 'close') {
      setopenstatus(false);
      setReferStep(1);
    }
  };

  const openReferAndEarn = () => {
    setopenstatus(true);
  };

  const renderReferContent = () => {
    switch (referStep) {
      case 1:
        return (
          <>
            <div className='col-12 signupform'>
              <div id='signin' className='container tab-pane active p-0'>
                <div className='row'>
                  <div className='col-md-12 '>
                    <div className='refernumber-hdng'>
                      <h1>Enter Mobile Number</h1>
                    </div>

                    <div className='sign-in-fields'>
                      <div className='form-group phone-input-box'>
                        <input
                          type='text'
                          className='form-control required'
                          id='Inputmobile'
                          aria-describedby='mobile'
                          placeholder='Mobile No'
                          value={mobileRefer}
                          onChange={(e) => handleChange(e, 'refer')}
                          maxLength={10}
                          onKeyPress={(e) => handleKeyPress(e, 'refer')}
                          autoComplete='off'
                        />

                        <span>
                          <img src={IndianFlag} alt='' /> +91
                        </span>
                      </div>
                      {mobileReferErr !== '' ? (
                        <p className='text-danger'>
                          <i
                            className='pe-2 fa fa-exclamation-circle'
                            aria-hidden='true'
                          ></i>
                          {mobileReferErr}
                        </p>
                      ) : null}

                      <div className='form-group mb-0'>
                        <div className='infobtn'>
                          <InfoLogo />
                          <p>
                            This mobile number will be used for login and
                            communications in the future. 
                          </p>
                        </div>

                        <button
                          type='submit'
                          className='makewhitcolor btnInuse btn-default makewhitcolor maekitfullwidth'
                          onClick={() => validateMobileNo('refer')}
                          style={{ marginTop: 30 }}
                        >
                          Get OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <div className='col-12 signupform'>
            <OTP_signIn data={resVerifyUser} gotoRefer={true} refId={refid} />
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <div className='container-fluid p-0'>
        <div className='main-height-box'>
          <div className='container my-4 mx-auto leftsidebox'>
            <div className='row'>
              <div className='col-md-6 col-sm-12 loginimg'>
                <div className='loginlefttxt'>
                  <div className='loginlefcntnt my-5'>
                    <h4 className='welcome-text'>
                      Open a Demat account online <br /> in just a few clicks
                      {/* We make it easy for everyone
                      <br /> to invest */}
                    </h4>
                    <p>
                      Ensuring ease of investment with IPOs
                      {/* Ensuring Ease of Investors Across Platforms */}
                    </p>
                    {showRefer && (
                      <button
                      onClick={openReferAndEarn}
                        className='referearnbtn'
                      >
                        Refer and Earn{' '}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              {renderLogin()}
              {openstatus && (
                <Dialog
                  maxWidth='xl'
                  open={openstatus}
                  onClose={() => referModalClick('close')}
                  aria-labelledby='alert-dialog-title'
                  aria-describedby='alert-dialog-description'
                >
                  <DialogTitle
                    id='alert-dialog-title-referal'
                    xl={{
                      textAlign: 'center',
                      fontSize: 'h5.fontSize',
                      fontWeight: 'bold',
                      textTransform: 'capitalize',
                    }}
                    style={{ minWidth: 600 }}
                  >
                    <button
                      type='button'
                      className='btn-close btn-close-white'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick={() => referModalClick('close')}
                    ></button>
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                      {renderReferContent()}
                    </DialogContentText>
                  </DialogContent>
                </Dialog>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//

export default SignIn;
